import React from 'react';

export async function RepaintProgress() {
    // Yield control to React loop so it can repaint the progress bar
    await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
}

interface ProgressProps {
    progress?: number;
}

const Progress: React.FC<ProgressProps> = ({ progress }) => {
    if (!progress) return null;
    return (
        <div>
            <progress value={progress} max={100}></progress>
            <span>{progress}%</span>
        </div>
    );
};

export default Progress;
